import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { ITEM_RENDER_MODE } from '../../constants';
import { Crumb } from '../Crumb';
/**
 * Варианты отображения для обычного айтема
 */
const NORMAL_MODES = [
    [ITEM_RENDER_MODE.ShortLabel, 'shortLabel'],
    [ITEM_RENDER_MODE.Ellipsis, 'label'],
    [ITEM_RENDER_MODE.Full, 'label'],
];
/**
 * Варианты отображения айтемов состоящих из одной иконки
 */
const ICON_ONLY_MODES = [[ITEM_RENDER_MODE.Full, 'label']];
const getItemModesRenderer = (firstItemIconOnly) => (item, index) => {
    const isIconOnlyMode = !index && firstItemIconOnly;
    const modes = isIconOnlyMode ? ICON_ONLY_MODES : NORMAL_MODES;
    return modes.map(([mode, labelProp]) => {
        const label = item[labelProp];
        // full mode не может отсутствовать, даже если там нет значения
        if (!label && mode !== ITEM_RENDER_MODE.Full) {
            return null;
        }
        return _jsx(Crumb, { useIconOnly: isIconOnlyMode, renderMode: mode, item: item }, item.id + mode);
    });
};
export const useItemModesRender = ({ firstItemIconOnly }) => useMemo(() => getItemModesRenderer(firstItemIconOnly), [firstItemIconOnly]);
